import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Focus management on every route change (design.md §10): after
 * navigation, focus lands on the page's h1 (every page has exactly one,
 * from PageHeader) or, failing that, on <main>, so a screen reader hears
 * where it is; the document title names the page too. Not on the first
 * render — the browser's own start is right there.
 */
export function RouteFocus({ productName }: { productName: string }) {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    const h1 = document.querySelector<HTMLElement>("main h1");
    const title = h1?.textContent?.trim();
    document.title = title ? `${title} — ${productName}` : productName;
    if (first.current) {
      first.current = false;
      return;
    }
    const target = h1 ?? document.getElementById("main");
    target?.focus({ preventScroll: false });
  }, [pathname, productName]);
  return null;
}
